import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { Autocomplete, Chip, TextField } from "@mui/material";
import React from "react";
export default function TagSelected(param) {
    var tagselected = param.tagselected, setTagSelected = param.setTagSelected, formdisabled = param.formdisabled;
    return /*#__PURE__*/ _jsx(Autocomplete, {
        multiple: true,
        freeSolo: true,
        options: [],
        value: tagselected,
        onChange: function(e, newValue) {
            return setTagSelected(newValue);
        },
        renderTags: function(value, getTagProps) {
            return value.map(function(option, index) {
                return /*#__PURE__*/ _jsx(Chip, _object_spread_props(_object_spread({
                    label: option
                }, getTagProps({
                    index: index
                })), {
                    sx: {
                        backgroundColor: "#FFF",
                        border: "1px solid rgba(76, 78, 100, 0.22)",
                        borderRadius: "20px",
                        fontSize: "16px",
                        color: "rgba(0,0,0,0.87)",
                        maxWidth: "100%",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        padding: "20px 10px",
                        "& .MuiChip-deleteIcon": {
                            color: "red"
                        },
                        "&.Mui-disabled": {
                            opacity: 1
                        },
                        "&.Mui-disabled .MuiChip-deleteIcon": {
                            color: "gray"
                        }
                    }
                }), index);
            });
        },
        renderInput: function(params) {
            return /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({}, params), {
                variant: "outlined",
                sx: {
                    minHeight: 85,
                    "& .MuiInputBase-root": {
                        minHeight: 85,
                        alignItems: "flex-start",
                        paddingTop: "10px"
                    },
                    "& .MuiInputBase-root.Mui-disabled": {
                        backgroundColor: "#F8F8F9"
                    }
                }
            }));
        },
        disabled: formdisabled
    });
}
